export class ImpactAllIndex {
  constructor(
    impactMaterialCount,
    impactCo2Count
  ) {
    this.impactMaterialCount = impactMaterialCount
    this.impactCo2Count = impactCo2Count
  }
}
